// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2wb59","tab":"ProcedureTabs_tab__3nTEk"};